import initLanguage, { getRailsLanguageByKey } from "../Mobile-mmt-react-native/apps/rails/src/vernacular/AppLanguage";
import React from "react";
import { View, Text, StyleSheet } from "react-native";
import { connect } from "react-redux";
import get from "lodash/get";

import { updateRailsLang } from "../Mobile-mmt-react-native/apps/rails/src/vernacular/vernacularActions";
import Loader from "../Mobile-mmt-react-native/apps/rails/src/pages/Common/Loader";

const getLoadingLabel = (lang) => {
  if (!lang) return '';
  if (lang === "eng") {
    return "Changing language to English";
  }
  if (lang === "hin") {
    return "भाषा को हिन्दी में बदल रहें हैं";
  }
};
function AppWithLang({ children, lang, updateLanguage }) {
  const [loading, setLoading] = React.useState(false);
  const currentLanguage = getRailsLanguageByKey("cookieCode");
  React.useEffect(() => {
    async function init() {
      setLoading(true);
      await initLanguage(lang);
      const cookieLang = getRailsLanguageByKey("cookieCode");
      console.log("COOKIE LANG", cookieLang);
      console.log("COOKIE Requested Lang", lang || "empty");
      if (lang === "" || lang !== cookieLang) {
        updateLanguage(cookieLang);
      }
      setLoading(false);
    }
    if ((currentLanguage === "" && lang === "") || (currentLanguage !== lang)) {
      init();
    }
  }, [lang]);
  if (lang === "" || loading) {
    return (
      <View style={styles.flex}>
        <Loader>
          <Text style={styles.loadingText}>{getLoadingLabel(lang)}</Text>
        </Loader>
      </View>
    )
  };
  return (
    <View style={styles.flex}>{children}</View>
  )
}

const styles = StyleSheet.create({
  flex: {
    flex: 1,
  },
  loadingText: {
    fontSize: 18,
    lineHeight: 18,
    color: "#007FFF",
    marginTop: 10,
  }
});
const mapStateToProps = (state) => {
  const lang = get(state, "railsVernacular.lang", "");
  return {
    lang,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateLanguage: (lang) => {
      dispatch(updateRailsLang(lang));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppWithLang);
